import moment from 'moment';
import 'moment/locale/ru';
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { Action, errorCatch, GET, JSXMap, QueryDetail, QueryOrder, READWITH, useAuth } from 'fennec-ui';
import REDUX_AkkauntiPolzovatelei from '../../../../../../objects/AkkauntiPolzovatelei/reducer';
import Icofont from 'react-icofont';
import { CollectionServerMobile } from 'fennec-ui';

var _ = require('lodash');

const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 0px",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})

function getCurrencyValue(value, color) {
	if (!value) {
		return (<span style={{ color: "grey" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (color) {
		return (<span style={{ color: color }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (value >= 0) {
		return (<span style={{ color: "rgb(63, 134, 0)" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (value < 0) {
		return (<span style={{ color: "red" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
}

function Account(props) {
	const classes = useStyles();
	const auth = useAuth();
	const { account, style } = props;

	const balance = (e) => {
		let v = _.get(e, "akkaunt.ostatok")
		if (v) return v;
		return 0;
	};

	const volume = balance(account);
	const title = () => (<div style={{
		color: "rgba(0, 0, 0, 0.85)",
		fontWeight: "500",
		fontSize: "16px"
	}}>
		Движения денег
	</div>);
	const emptyArray = React.useCallback(() => [], []);
	const filters = React.useCallback(() => [
		{
			name: "summa",
			filterType: "range",
			func: ["min", "max"],
			// min: -25,
			// max: 10000,
			// step: 7,
			// step: 1000,

			sort: true,
			filter: true,
		},
		{
			label: "Дата",
			name: "updatedAt",
			type: "date",
			filterType: "range",
			sort: true,
			filter: true,
			sorted: "DESC",
		},
		// {
		// 	name: "status",
		// 	filterType: "group",
		// 	// source: "/api/query/zakazstatus",
		// 	display: (o) => o.nazvanie,
		// 	sort: true,
		// 	filter: true,
		// },
		// {
		// 	name: "ekvairingZakaz.paymentState",
		// 	filterType: "group",
		// 	// source: "/api/query/zakazstatus",
		// 	display: (o) => o.opisanie,
		// 	filter: true,
		// },
		// {
		// 	name: "meropriyatie.mestoProvedeniya",
		// 	filterType: "group",
		// 	queryFilter: [
		// 		QueryDetail("model"),
		// 		QueryOrder("name", "ASC"),
		// 		// QueryParam("w-region","77")
		// 	],
		// 	// source: "/api/query/city",
		// 	display: (o) => o.name,
		// 	sort: true,
		// 	filter: true,
		// }
	], []);
	return (<>
		<Action
			auth={auth}
			action={(values, unlock, close) => {

			}}
			readonly={true}
			noAntForm={true}
			titles={{
				header: (<div style={{ textAlign: "center" }}>
					<div>
						Движения денег по счету
					</div>
					<div>
						<div style={{ fontSize: "12px", color: "grey" }}>
							{(account?.akkaunt?.akkauntTypeID == 2) && <span>Основной счет</span>}
							{(account?.akkaunt?.akkauntTypeID == 9) && <span>Накопительный счет</span>}
						</div>
						<div>
							<span>№{account?.akkaunt?.nomerAkkaunta}</span>
						</div>
					</div>
				</div>)

			}}
			mode={"func"}
			form={(props) => {
				const { auth, form, submit } = props;
				return (<div style={{ padding: "0 10px" }}>
					<CollectionServerMobile
						auth={auth}
						name={"DvizheniyaDeneg"}
						source={`/api/dvizheniyadeneg/byaccount/${account.akkaunt.ID}`}

						filters={filters}
						size={"small"}
						mode={"list"}
						// titleFunc={title}
						noheader={true}
						render={(item, idx, options) => {
							return (<div key={idx} style={{ width: "100%" }}>
								<div className={classes.ticket} style={{ display: "flex" }}>
									<div style={{ flex: "auto", width: "100%", fontSize: "13px" }}>
										<div style={{ alignSelf: "flex-start", textAlign: "start", padding: "0px 5px 0px 0px", fontWeight: "300", fontSize: "13px", display: "flex", justifyContent: "space-between" }}>
											<div>{moment(item.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}</div>
											<div style={{ flex: "135px" }}>
												<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "13px" }}>
													{(item.prikhodID == account.akkaunt.ID) && <div style={{ color: "rgb(63, 134, 0)" }}>+ {Math.abs(Number(item.summa.toFixed(2))).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>}
													{(item.ukhodID == account.akkaunt.ID) && <div style={{ color: "red" }}>- {Math.abs(Number(item.summa.toFixed(2))).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>}
												</div>
											</div>
										</div>
										<div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
											<span style={{ fontWeight: "400", fontSize: "12px" }}>
												{(item.ukhodID == account.akkaunt.ID) && <Icofont icon="user-alt-3" />}
												{(item.ukhodID != account.akkaunt.ID) && ((item.ukhodID) ? <span>№{item.ukhodNomer}</span> : "Зачисление денежных средств")}
											</span>
											<Icofont icon="long-arrow-right" />
											<span style={{ fontWeight: "400", fontSize: "12px" }}>
												{(item.prikhodID == account.akkaunt.ID) && <Icofont icon="user-alt-3" />}
												{(item.prikhodID != account.akkaunt.ID) && ((item.ukhodID) ? <span>№{item.prikhodNomer}</span> : "Вывод денежных средств")}
											</span>
										</div>
										<div style={{ fontWeight: "300" }}>
											{item.opisanie}
										</div>
									</div>

								</div>
							</div>)
						}}
					/></div>
				)
			}}
			trigger={(click) => (
				<div onClick={click} style={{ display: "flex", justifyContent: "space-between", gap: "5px", ...style }}>
					<div>
						<div style={{ fontSize: "12px", color: "grey" }}>
							{(account?.akkaunt?.akkauntTypeID == 2) && <span>Основной счет</span>}
							{(account?.akkaunt?.akkauntTypeID == 9) && <span>Накопительный счет</span>}
						</div>
						<div>
							<span>№{account?.akkaunt?.nomerAkkaunta}</span>
						</div>
					</div>
					<div style={{ textAlign: "right" }}>
						{getCurrencyValue(account?.akkaunt?.ostatok)}
					</div>
				</div>
			)}
		/>


		{/* <div>
			<div style={{ color: "rgba(0, 0, 0, 0.45)" }}>Остаток по счету:</div>
			<div style={{ fontSize: "24px", color: (volume < 0) ? '#cf1322' : '#3f8600' }}>{Number(volume.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.</div>
		</div> */}
		{/* {account && <>
			<CollectionServerMobile
				auth={auth}
				name={"DvizheniyaDeneg"}
				source={`/api/dvizheniyadeneg/byaccount/${account.akkaunt.ID}`}

				filters={filters}
				size={"small"}
				mode={"list"}
				titleFunc={title}
				render={(item, idx, options) => {
					return (<div key={idx} style={{ width: "100%" }}>
						<div className={classes.ticket} style={{ display: "flex" }}>
							<div style={{ flex: "auto", width: "100%", fontSize: "13px" }}>
								<div style={{ alignSelf: "flex-start", textAlign: "start", padding: "0px 5px 0px 0px", fontWeight: "300", fontSize: "13px" }}>
									{moment(item.UpdatedAt).format("DD.MM.YYYY HH:mm:ss")}
								</div>
								<div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
									<span style={{ fontWeight: "400", fontSize: "12px" }}>
										{(item.ukhodID == account.akkaunt.ID) && <Icofont icon="user-alt-3" />}
										{(item.ukhodID != account.akkaunt.ID) && ((item.ukhodID) ? <span>№{item.ukhodNomer}</span> : "Зачисление денежных средств") }
									</span>
									<Icofont icon="long-arrow-right" />
									<span style={{ fontWeight: "400", fontSize: "12px" }}>
										{(item.prikhodID == account.akkaunt.ID) && <Icofont icon="user-alt-3" />}
										{(item.prikhodID != account.akkaunt.ID) && ((item.ukhodID) ? <span>№{item.prikhodNomer}</span> : "Вывод денежных средств") }
									</span>
								</div>
								<div style={{ fontWeight: "300" }}>
									{item.opisanie}
								</div>
							</div>
							<div style={{ flex: "135px" }}>
								<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "13px" }}>
									{(item.prikhodID == account.akkaunt.ID) && <div style={{ color: "rgb(63, 134, 0)" }}>+ {Math.abs(Number(item.summa.toFixed(2))).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>}
									{(item.ukhodID == account.akkaunt.ID) && <div style={{ color: "red" }}>- {Math.abs(Number(item.summa.toFixed(2))).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>}
								</div>
							</div>
						</div>
					</div>)
				}}
			/>
		</>
		} */}
	</>);
}

export default function Myaccount(props) {
	const auth = useAuth();
	const dispatch = useDispatch();
	// const [tickets, setTickets] = React.useState();

	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	// AkkauntiPolzovatelei - Аккаунты пользователей
	// AkkauntiShkol - Аккаунты школ
	// AkkauntiRegionalnikhOtdelenii - Аккаунты региональных отделений
	// AkkauntiOrganizatorov - Аккаунты организаторов
	// AkkauntiFed - Аккаунт федерации
	// AkkauntiMeropriyatii - Аккаунты мероприятий
	// console.log(role_by_name);

	useEffect(() => {
		// GET(auth, "/api/ticket/actual", ({ data }) => {
		// 	if (data) {
		// 		setTickets(data);
		// 	}
		// }, errorCatch)
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryOrder("akkaunt.akkauntType.ID", "ASC"),
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	}, []);

	return (
		<>
			<div style={{ padding: "10px 5px", height: "100%" }}>
				{JSXMap(akkauntiPolzovatelei, (e, idx) => <Account key={idx} auth={auth} account={e} style={{ padding: (idx != 0) ? "10px 0px 0px 0px" : "" }} />)}
			</div>
		</>
	);
}
